<template>
  <div id="app"
    v-loading.fullscreen.lock="showLoading">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {}
  },
  computed: {
    showLoading () {
      return this.$store.state.showLoading
    }
  }
}
</script>

<style>
html{
  height: 100%;
}
body{
  padding: 0;
  margin: 0;
  height: 100%;
}
#app{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue